import { render, staticRenderFns } from "./Alphalist.vue?vue&type=template&id=197791a1&scoped=true"
import script from "./Alphalist.vue?vue&type=script&lang=js"
export * from "./Alphalist.vue?vue&type=script&lang=js"
import style0 from "./Alphalist.vue?vue&type=style&index=0&id=197791a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197791a1",
  null
  
)

export default component.exports